module.exports = __webpack_public_path__ + "img/cards.bd819b85.png";